import { AbstractControlOptions, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ControlConfig, FormGroupConfig } from './form-config.model';

export abstract class AbstractForm<T> {

    public form: UntypedFormGroup = null;

    protected constructor(protected fb: UntypedFormBuilder) {
    }

    protected abstract get formGroupConfig(): FormGroupConfig<T>;

    protected get formOptions(): AbstractControlOptions | null {
        return null;
    }

    public initForm(): UntypedFormGroup {
        const config = this.formGroupConfig;
        const options = this.formOptions;
        this.form = this.fb.group(config, options);
        return this.form;
    }

    public get f(): ControlConfig<T> {
        return this.form.controls as ControlConfig<T>;
    }

    abstract sanitize(entity: T): T;

}
